import { EventEmitter } from "events";

const eventBus = new EventEmitter();

// EventEmitter warns once a single event name exceeds 10 listeners, on the assumption that a high
// count means listeners are leaking. Here one listener per event name is legitimately registered
// per mounted component -- LineItem subscribes to 'reportRemoved', and a template renders one
// LineItem per line item, so any template with more than ten line items crosses the threshold
// through correct behaviour alone.
//
// This is raised ONLY because the actual leak it was masking is fixed: LineItem's effect now
// removes its listener on cleanup, so the count tracks mounted components instead of growing
// without bound. Raising this limit on its own would have hidden the leak rather than fixing it.
//
// If this warning ever reappears, treat it as a real missing cleanup and find it -- do not raise
// the number again.
eventBus.setMaxListeners(100);

export default eventBus;
